import React, { useCallback, useMemo } from "react";
import images from "../../../images";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import TaskQuest from "../../../components/Quest/TaskQuest";
import RequirementCard from "../../../components/Quest/RequirementCard";
import { useSelector } from "react-redux";
import LoadingCommon from "../../../components/common/LoadingStatus/LoadingCommon";
import {
  useGetListBusinessLocationLatLongQuery,
  useGetUserInfoQuery,
} from "../../../services/apiSlice";
import { useTranslation } from "react-i18next";

const containerStyle = {
  width: "100%",
  height: "180px",
  borderRadius: "12px",
};

const StepPreview = ({ questName, tokenXP = {}, shopperCount }) => {
  const { t } = useTranslation();

  const { description, requirement, expiryDate, thumbnails } = useSelector(
    (state) => state.common
  );
  const reduxLocations = useSelector(
    (state) => state.common?.locationList || []
  );

  const addresses = reduxLocations.map((location) =>
    `${location.address || ""}, ${location.district || ""}, ${
      location.city || ""
    }, ${location.country || ""}`.trim()
  );

  const { data: userInfo, isLoading: isLoadingUserInfo } =
    useGetUserInfoQuery();

  const defaultProps = {
    center: { lat: 10.99835602, lng: 77.01502627 },
    zoom: 11,
  };

  const body = {
    addresses: addresses,
  };
  const {
    data: locationListDataLatLong,
    isLoading: isLoadingLocationListDataLatLong,
  } = useGetListBusinessLocationLatLongQuery(
    { body },
    { skip: addresses.length === 0 }
  );

  const mapCenter =
    locationListDataLatLong?.data?.length > 0
      ? {
          lat: Number(locationListDataLatLong.data[0].latitude),
          lng: Number(locationListDataLatLong.data[0].longitude),
        }
      : defaultProps.center;

  // const allLocations = locationListDataLatLong?.data || [];
  const allLocations = useMemo(
    () => locationListDataLatLong?.data || [],
    [locationListDataLatLong?.data]
  );

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  const onMapLoad = useCallback(
    (map) => {
      if (allLocations.length > 0) {
        const bounds = new window.google.maps.LatLngBounds();
        allLocations.forEach((location) => {
          bounds.extend({
            lat: Number(location.latitude),
            lng: Number(location.longitude),
          });
        });
        map.fitBounds(bounds);
      }
    },
    [allLocations]
  );

  if (loadError) {
    // console.error("Error loading Google Maps:", loadError);
    return <div>{t("base.errorLoadingMap")}</div>;
  }

  if (!isLoaded) {
    return <LoadingCommon />;
  }

  return (
    <div className="flex flex-col mx-auto w-full ">
      {/* {isLoadingLocationListDataLatLong && <LoadingCommon />} */}
      <LoadingCommon
        statusLoading={isLoadingLocationListDataLatLong || isLoadingUserInfo}
      />
      <div className="flex flex-col w-full">
        <TaskQuest
          imagesNameShop={
            userInfo?.data?.avatar?.file_path
              ? `${process.env.REACT_APP_URL_IMAGE}/${userInfo?.data?.avatar?.file_path}`
              : images.LogoProfile
          }
          shopName={questName}
          branchName={userInfo?.data.company_name}
          description={description}
          estTime={tokenXP?.time_require || "0"}
          token={tokenXP?.tokens || 0}
          expireIn={expiryDate}
          slotAvailable={shopperCount * Number(reduxLocations?.length)}
          favoritesIcon={images.FavoritesIcon}
          thumbnails={thumbnails}
          // consumerStatus={"NOT_STARTED"}
        />
        <RequirementCard requirement={requirement} />
        <div
          className="mt-4 w-full rounded-xl"
          style={{ position: "relative" }}
        >
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={mapCenter}
            zoom={defaultProps.zoom}
            onLoad={onMapLoad}
            onUnmount={(map) => {}}
          >
            {allLocations.map((location, index) => (
              <Marker
                key={index}
                position={{
                  lat: Number(location.latitude),
                  lng: Number(location.longitude),
                }}
                icon={{
                  url: images.DotMapIconBlue,
                  scaledSize: new window.google.maps.Size(40, 40),
                }}
              />
            ))}
          </GoogleMap>
        </div>
      </div>
    </div>
  );
};

// StepPreview.propTypes = {
//   questName: PropTypes.string.isRequired,
//   tokenXP: PropTypes.shape({
//     time_require: PropTypes.string,
//     tokens: PropTypes.number,
//   }).isRequired,
//   shopperCount: PropTypes.number.isRequired,
// };

export default StepPreview;
